import { MobileOnly } from '$tablet-app/src/app/platform';
import { Address } from '@akin-home/amplify';
import {
  getGeocodeCountryText,
  getGeocodeLocalityText,
  getGeocodePostcode,
  getGeocodeStateCode,
  getGeocodeStreetText,
} from '@akin-home/google-maps/geocode';
import { useRef } from 'react';
import {
  GooglePlaceData,
  GooglePlaceDetail,
  GooglePlacesAutocomplete,
  GooglePlacesAutocompleteRef,
} from 'react-native-google-places-autocomplete';
import styled from 'styled-components/native';

interface Props {
  address: Address;
  onChange(address: Address): void;
}

export const AddressField = (props: Props) => {
  const { address } = props;

  const autocomplete = useRef<GooglePlacesAutocompleteRef>(null);

  const onChange = (key: keyof Address) => (value: string) =>
    props.onChange({ ...address, [key]: value });

  const onSelectAddress = (
    _: GooglePlaceData,
    details: GooglePlaceDetail | null
  ) => {
    autocomplete.current?.setAddressText('');

    const parsed_data = details as any;

    props.onChange({
      ...address,
      street: getGeocodeStreetText(parsed_data),
      city: getGeocodeLocalityText(parsed_data),
      state: getGeocodeStateCode(parsed_data),
      postcode: getGeocodePostcode(parsed_data),
      country: getGeocodeCountryText(parsed_data),
    });
  };

  return (
    <Container>
      <MobileOnly>
        <GooglePlacesAutocomplete
          ref={autocomplete}
          placeholder="Search for an address"
          disableScroll
          keepResultsAfterBlur
          keyboardShouldPersistTaps="always"
          onPress={onSelectAddress}
          fetchDetails
          query={autoCompleteQuery}
          textInputProps={autoCompleteInputProps}
        />
      </MobileOnly>

      <AddressInput
        placeholder="Street"
        value={address.street || ''}
        onChangeText={onChange('street')}
      />
      <AddressInput
        placeholder="City"
        value={address.city || ''}
        onChangeText={onChange('city')}
      />
      <AddressInput
        placeholder="Postcode"
        value={address.postcode || ''}
        onChangeText={onChange('postcode')}
      />
      <AddressInput
        placeholder="State"
        value={address.state || ''}
        onChangeText={onChange('state')}
      />
      <AddressInput
        placeholder="Country"
        value={address.country || ''}
        onChangeText={onChange('country')}
      />
    </Container>
  );
};

const Container = styled.View`
  gap: 20px;
  flex: 1;
`;

const AddressInput = styled.TextInput`
  flex: 1;
  font-size: 22px;
  font-weight: 600;
  border-bottom-width: 1px;
  border-bottom-color: lightgrey;
`;

const autoCompleteInputProps = {
  InputComp: AddressInput,
};

const autoCompleteQuery = {
  key: 'AIzaSyDlrjhkxnVnquQJXFLe1Z30CXHMsZDsZ2I',
  language: 'en',
  components: 'country:au',
};